import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import { GlobalLoaderService } from 'src/app/modules/shared/_services/global-loader.service';
import { AlertMessageService } from '../../_services/alert-message.service';
import { SharedService } from '../../_services/shared.service';
import { PARAMS } from 'src/app/_configs/params';
import { Subscription } from 'rxjs';

interface DataLayerEvent {
  event: string;
  [key: string]: any;
}
declare const dataLayer: DataLayerEvent[];
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FooterComponent implements OnInit, OnDestroy {

  currentYear: number = new Date().getFullYear();
  currentUrl: string = '';
  formGroup!: FormGroup;
  isSubmitted: boolean = false;
  isDisableFormOnContactusPage: boolean = false;
  private routerSubscription: Subscription | undefined;

  constructor(
    private sharedService: SharedService,
    private alertMessageService: AlertMessageService,
    private globalLoaderService: GlobalLoaderService,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.initializeForm();
    this.checkIfOnContactUsPage();
    this.getRoute();
  }

  ngOnInit(): void {
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
  }

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }

  private initializeForm(): void {
    this.formGroup = this.fb.group({
      name: ['', Validators.required],
      email: ['', [
        Validators.required,
        Validators.pattern(PARAMS.REGEX.EMAIL_VALIDATOR_REGEX)
      ]],
      phone: ['', [
        Validators.required,
        Validators.pattern(PARAMS.REGEX.INDIAN_MOBILE_NUMBER_VALIDATOR_REGEX)
      ]],
      description: [''],
      gstNum: ['', Validators.required]
    });
  }

  get formControls() {
    return this.formGroup.controls;
  }

  private checkIfOnContactUsPage(): void {
    this.isDisableFormOnContactusPage = this.router.url === PARAMS.ROUTING_PATHS.CONTACT_US;
  }

  private getRoute(): void {
    this.router.events.forEach((event: any) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
  }

  onSubmit(): void {
    this.isSubmitted = true;
    this.clearFormErrorMessage();

    if (this.formGroup.invalid) {
      return;
    }

    this.setLoader(true);
    this.formGroup.value.requestType = PARAMS.STATIC_PARAMS.REQUEST_TYPE_FOOTER_CONTACT_US;

    this.sharedService.contactUs(this.formGroup.value).subscribe({
      next: () => this.handleSuccess(),
      error: (err: any) => this.handleError(err),
      complete: () => this.setLoader(false)
    });
  }

  private handleSuccess(): void {
    this.alertMessageService.addSuccess('We have received your request and will get back to you shortly').show();
    this.pushNormalUser();
    this.formGroup.reset();
    this.isSubmitted = false;
    this.setLoader(false);
  }

  private handleError(err: any): void {
    console.error('Error submitting contact form:', err.error);
    const errorMessage = err?.error?.gstNum || err?.error?.message;
    this.alertMessageService.addError(errorMessage).show();
    this.setLoader(false);
  }

  private setLoader(state: boolean): void {
    this.globalLoaderService.setLoaderState(state);
  }

  pushNormalUser() {
    if (typeof dataLayer !== 'undefined') {
      dataLayer.push({
        'event': 'get_in_touch_contact'
      });
    } else {
      console.warn("dataLayer is not defined.");
    }
  }

  private clearFormErrorMessage(): void {
    setTimeout(() => {
      this.isSubmitted = false;
    }, 5000);
  }
}